import React from 'react';
import { Email } from '@mui/icons-material';
import { Typography, Stack } from '@mui/material';
import { TooltipUI } from '../../Interface';
import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';

const EmailField = ({ email }) => {
  const handleCopy = async () => {
    await navigator.clipboard.writeText(email);

    addNotification({
      content: 'E-mail cím a vágólapra másolva!',
      type: NotificationType.SUCCESS,
    });
  };
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
      <Email fontSize="small" sx={{ flexShrink: 0 }} />
      <TooltipUI title={email} arrow>
        <Typography
          color="primary.main"
          onClick={handleCopy}
          noWrap
          sx={{
            minWidth: 0,
            cursor: 'pointer',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {email}
        </Typography>
      </TooltipUI>
    </Stack>
  );
};

export default EmailField;
